import { ISearchParameters, ITableReport } from "./TableInterfaces";
import { DropdownItem } from "./dropdownInterfaces";

export interface IConnectionsReport extends ITableReport {
  name: string;
  connectionStatus: number;
  time: string;
  captchaMsg: string;
  imageAddress: string;
  autoLogin: boolean;
  canTrade: boolean;
  portfoGroupName: string;
  estimated?: string | null;
}

export interface IConnectionsSearchParams extends ISearchParameters {
  name?: string;
  connectionStatus?: number;
  dontShowOnline?: boolean;
  userIds?: Array<number>;
  exchangeType?: ExchangeType;
  broker?: number;
  oms?: number;
  portfolioGroupId?: number | string;
}

export interface IConnectionFilterOptions {
  brokers: DropdownItem[];
  oms: DropdownItem[];
}

export enum ConnectionStatus {
  Online = 1,
  Disconnected = 2,
  Offline = 3,
}

export interface getUserStatisticsResp {
  onlineUserCount: number;
  offlineUserCount: number;
  disconnectedUsercount: number;
}

export interface User extends DropdownItem {
  connectionStatus: ConnectionStatus;
  hasConnectedAccount?: boolean;
}

export interface IUserConnectionsSearchParams {
  accountName: string;
}

export interface ILoginHourConfig {
  startTime: string;
  endTime: string;
  commodityStartTime: string;
  commodityEndTime: string;
}

export interface ILoginLogSearchParam extends ISearchParameters {
  userId: number;
}

export interface LoginLogReport extends ITableReport {}

export interface IToggleAutoLogin {
  userId: number;
  enable: boolean;
}
export interface IToggleAutoBulkLogin {
  userIds: number[];
  enable: boolean;
}

export enum ExchangeType {
  CommodityExchange = 1,
  StockExchange = 2,
}
